export const TEAM_CREATION_STEP_PATHS: Record<string, string> = {
  registration: '/create/team-name',
  team_name: '/create/team-name',
  'team-name': '/create/team-name',
  game_modes_selection: '/create/game-modes-selection',
  'game-modes-selection': '/create/game-modes-selection',
  wildcard_selection: '/create/shop',
  payment: '/create/shop',
  shop: '/create/shop',
  completed: '/dashboard'
}

export const getTeamCreationPath = (step?: string | null) => {
  if (!step) return '/create/team-name'
  return TEAM_CREATION_STEP_PATHS[step] || '/create/team-name'
}

export const getTeamCreationResumePath = ({
  instanceId,
  creationCompleted,
  creationStep
}: {
  instanceId: string
  creationCompleted?: boolean | null
  creationStep?: string | null
}) => {
  if (creationCompleted) {
    return '/dashboard'
  }

  switch (creationStep) {
    case 'team_name':
      return `/create/game-modes-selection?instance=${instanceId}`
    case 'game_modes_selection':
    case 'tier_selection': // legacy backend value — forward to next required step
      return `/create/leagues-selection?instance=${instanceId}`
    case 'leagues_selection':
      return `/create/shop?instance=${instanceId}`
    case 'wildcard_selection':
    case 'payment':
    case 'shop':
      return `/create/shop?instance=${instanceId}`
    default:
      return `/create/team-name?instance=${instanceId}`
  }
}
